module.exports = __webpack_public_path__ + "static/media/banner-keyman-2@2x.6d3a730a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-keyman-2@2x.png
// module id = 1252
// module chunks = 1